import {
  BedDouble,
  Users,
  Snowflake,
  Bath,
  Clock,
  Stethoscope,
  Baby,
  HeartPulse,
  Droplet,
  Flame,
  Leaf,
  UtensilsCrossed,
  Salad,
  Flower2,
  Activity,
  Wifi,
  Car,
  BedSingle,
  Shirt,
  Sparkles,
  Tv,
  Refrigerator,
  CheckCircle,
  icons,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

export const iconKeyToIcon: Record<string, LucideIcon> = {
  private_room: BedDouble,
  shared_room: Users,
  ac_room: Snowflake,
  attached_bathroom: Bath,
  nursing_24x7: Clock,
  doctor_on_call: Stethoscope,
  lactation_consultant: Baby,
  baby_care_nurse: HeartPulse,
  oil_massage: Droplet,
  postnatal_massage: Droplet,
  hot_water_bag: Flame,
  ayurvedic_care: Leaf,
  kerala_food: UtensilsCrossed,
  nutritionist_diet: Salad,
  yoga_meditation: Flower2,
  physiotherapy: Activity,
  wifi: Wifi,
  parking: Car,
  attendant_bed: BedSingle,
  laundry: Shirt,
  housekeeping: Sparkles,
  tv: Tv,
  refrigerator: Refrigerator,
};

const toIconKey = (name: string) =>
  name
    .replace(/([a-z0-9])([A-Z])/g, "$1_$2")
    .replace(/([A-Z])([A-Z][a-z])/g, "$1_$2")
    .toLowerCase();

// The legacy amenity keys remain available alongside every icon in Lucide.
// Keeping this catalogue here also lets existing non-edit surfaces render a
// newly selected icon without changing their UI.
export const amenityIconLibrary: Record<string, LucideIcon> = {
  ...Object.fromEntries(
    Object.entries(icons).map(([name, Icon]) => [toIconKey(name), Icon]),
  ),
  ...iconKeyToIcon,
};

export const getAmenityIcon = (key: string): LucideIcon =>
  amenityIconLibrary[key] ?? CheckCircle;
